(function () {
  'use strict';
  angular.module('benefits')
    .component('groupInfo', {
        bindings: {
          refId: '='
        },
        controller: ['benefitService', function selectMemberController(benefitService) {
          var ctrl = this;
          this.$onInit = function () {
            var ctrl = this;
            benefitService.planSummaryPromise.then(function(data) {
              ctrl.model = data;
              if(ctrl.model && ctrl.model.coordinationOfBenefits == "standard") {
                ctrl.model.coordinationOfBenefits = "Standard";
              } else if(ctrl.model && ctrl.model.coordinationOfBenefits == "non duplication") {
                ctrl.model.coordinationOfBenefits = "Non Duplication";
              } else {
                ctrl.model.coordinationOfBenefits = "Not Applicable";
              }
              ctrl.model.serviceUnavailable = !data || data.serviceUnavailable;
            });
          };
        }],
        templateUrl: 'js/benefits/groupInfo.html' + appVersion
      }
    );
})();